module.exports = __webpack_public_path__ + "media/images/redesign-images/icons/icon-step-4-4094d7b17475c7c3c5f9165e21f7e8ca.svg";